import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const EyeSee = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m2.47 11.119-.651-.372zm19.06 0 .651-.371zM2.47 12.88l-.651.371zm19.06 0 .651.372zM3.122 11.49C5.437 7.427 8.769 5.5 12 5.5s6.563 1.927 8.878 5.99l1.303-.742C19.658 6.319 15.88 4 12 4S4.342 6.319 1.819 10.747zm-1.303 1.762C4.342 17.681 8.12 20 12 20s7.658-2.319 10.181-6.747l-1.303-.743C18.563 16.573 15.231 18.5 12 18.5s-6.563-1.927-8.878-5.99zm0-2.505a2.53 2.53 0 0 0 0 2.505l1.303-.742a1.03 1.03 0 0 1 0-1.02zm19.06.743c.18.316.18.704 0 1.02l1.302.743a2.53 2.53 0 0 0 0-2.505zM14.5 12a2.5 2.5 0 0 1-2.5 2.5V16a4 4 0 0 0 4-4zM12 14.5A2.5 2.5 0 0 1 9.5 12H8a4 4 0 0 0 4 4zM9.5 12A2.5 2.5 0 0 1 12 9.5V8a4 4 0 0 0-4 4zM12 9.5a2.5 2.5 0 0 1 2.5 2.5H16a4 4 0 0 0-4-4z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 4c3.88 0 7.658 2.32 10.181 6.748a2.53 2.53 0 0 1 0 2.505C19.658 17.68 15.88 20 12 20s-7.658-2.32-10.181-6.748a2.53 2.53 0 0 1 0-2.505C4.342 6.32 8.12 4 12 4m-3.625 8a3.625 3.625 0 1 1 7.25 0 3.625 3.625 0 0 1-7.25 0'
        fill='currentColor'
      />
    )}
  </IconBase>
);
